import { brandPrimaryHover, header, label } from '../../../web/styles/colors';
import { CssSelectors } from '../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	addMore: {
		color: brandPrimaryHover,
		display: 'inline-flex',
		...CssSelectors.allChildren(
			{
				marginRight: 8,
			},
			'svg'
		),
	},
	container: {
		width: 457,
	},
	dropdownSelect: {
		maxWidth: 120,
	},
	footer: {
		marginBottom: 24,
		...CssSelectors.allChildren(
			{
				marginRight: 10,
			},
			':first-child'
		),
	},
	formControl: {
		margin: '0 0 16px',
		...CssSelectors.allChildren(
			{
				color: header,
				fontSize: 12,
			},
			'small'
		),
	},
	formControlInputWrap: {
		display: 'flex',
		width: '100%',
		...CssSelectors.allChildren(
			{
				marginRight: 10,
				width: 'calc(100% - 22px)',
			},
			'.text-input'
		),
	},
	phraseInput: {
		flexGrow: 1,
		marginRight: 10,
	},
	header: {
		color: brandPrimaryHover,
		fontSize: 24,
		margin: '0 0 23px',
	},
	label: {
		color: label,
		display: 'block',
		fontSize: 14,
		margin: '0 0 8px',
	},
});
